export default function () {
  const HEADER_SEARCH_SELECTOR = '[data-type*="header-search"]';
  const HEADER_SEARCH_BTN_SELECTOR = '[data-type*="header-search-btn"]';
  const HEADER_SEARCH_FIELD_SELECTOR = '[data-type*="header-search-field"]';

  const search = document.querySelector(HEADER_SEARCH_SELECTOR);
  if (!search) return;

  const searchBtn = search.querySelector(HEADER_SEARCH_BTN_SELECTOR);
  const searchField = search.querySelector(HEADER_SEARCH_FIELD_SELECTOR);

  searchBtn.addEventListener('click', () => {
    searchField.classList.toggle('opened');
  });

  document.addEventListener('click', (e) => {
    if (!e.target.closest(HEADER_SEARCH_SELECTOR)) {
      searchField.classList.remove('opened');
    } else {
      e.stopPropagation();
    }
  });
}



// WEBPACK FOOTER //
// ./scripts/elements/header-search.js